module.exports = __webpack_public_path__ + "static/media/landing-preview-header-bg.db0c1918.png";